<template>
    <dashboard-criticality-card
        title="İSG Eğitimleri"
        :fields="fields"
        :provider="provider"
        :enabled-levels="enabledLevels"
        excel-file-name="ISG_Egitimleri" />
</template>

<script>
import OHSEducationApi from "@/api/ohs-education";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "Başlangıç Tarihi", key: "ValidityStartDateStr" },
                { name: "Bitiş Tarihi", key: "ValidityEndDateStr" },
                { name: "Kalan Gün", key: "RemainingDate" },
            ],
        };
    },
    methods: {
        provider() {
            return OHSEducationApi.Employee.Dashboard();
        },
    },
};
</script>
